import {Component, OnInit} from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {patternSymbolsImages} from '../symbols-mockup';

@Component({
  selector: 'app-count-pattern',
  templateUrl: './count-pattern.component.html',
  styleUrls: ['./count-pattern.component.css']
})
export class CountPatternComponent extends GeneralExerciseComponent implements OnInit {

  pattern: number[];
  patternSequence: number[];
  possibleSolutions: number[];
  clickedValue: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.generateNextExercise();
  }

  initValues() {
    this.pattern = [];
    this.patternSequence = [];
    this.clickedValue = -1;
    this.solved = false;

    if (this.level === 1) {
      this.possibleSolutions = [2, 3];
    } else {
      this.possibleSolutions = [2, 3, 4, 5];
    }
  }

  checkSolution() {
    if (this.clickedValue === (this.patternSequence.length / this.pattern.length)) {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get('correctlySolved'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlySolved'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.initValues();

    this.pattern = this.generatePattern();
    this.patternSequence = this.generatePatternSequence(this.pattern);
  }

  getPatternLength() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 2);
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 2) + 3);
    } else {
      return Math.floor((Math.random() * 3) + 4);
    }
  }

  getSequenceLength() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 2);
    } else {
      return Math.floor((Math.random() * 4) + 2);
    }
  }

  generatePattern() {
    const length = this.getPatternLength();
    const pattern = [];
    let countDifferentSymbols = 0;

    for (let i = 0; i < length; i++) {
      const randomSymbol = Math.floor((Math.random() * 15));
      if (pattern.indexOf(randomSymbol) === -1) {
        countDifferentSymbols++;
      }
      pattern.push(randomSymbol);
    }

    // To avoid that the pattern is only one symbol.
    if (countDifferentSymbols === 1) {
      let randomSymbol = Math.floor((Math.random() * 15));
      while (pattern.indexOf(randomSymbol) !== -1) {
        randomSymbol = Math.floor((Math.random() * 15));
      }
      pattern[length - 1] = randomSymbol;
    }

    return pattern;
  }

  generatePatternSequence(pattern: number[]) {
    const length = this.getSequenceLength();
    const sequence = [];
    for (let i = 0; i < length; i++) {
      for (let j = 0; j < pattern.length; j++) {
        sequence.push(pattern[j]);
      }
    }

    return sequence;
  }

  isActive(value: number) {
    return value === this.clickedValue;
  }

  setClickedValue(value: number) {
    this.clickedValue = value;
    this.checkSolution();
  }

  getSymbolImage(idx: number) {
    return patternSymbolsImages[idx];
  }

  computeState() {
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
  }

  setLevel(level: number) {
    if (level !== this.level) {
      super.setLevel(level);
      this.generateNextExercise();
    }
  }
}
